// extracted by mini-css-extract-plugin
module.exports = {"detailLoader":"Loader_detailLoader__10KQi","detailLoaderAbsolute":"Loader_detailLoaderAbsolute__1_gBz","LoadingScreenContainer":"Loader_LoadingScreenContainer__1xm3t"};